import { useRef } from 'react';
import { config } from 'config.js';
import { createFlowStore } from '../store/flowStore';
import { createUiStore } from '../store/uiStore';
import { createSessionStore } from '../store/sessionStore';
import { loadFromLocalStorage } from '../session/localPersistence';

export function useStoresSingleton(flowRegistry, defaultFlowId) {
    // Ref keeps the same instances across re-renders.
    const ref = useRef(null);
    if (ref.current === null) {
        const persisted = config.AUTO_PERSIST_LOCAL_STORAGE ? loadFromLocalStorage() : null;
        const flowId = persisted && persisted.currentFlowId != null ? persisted.currentFlowId : defaultFlowId;
        const { store: flowStore, events: flowEvents } = createFlowStore({
            flowRegistry, flowId,
        });
        if (persisted && persisted.currentItemId) {
            try { flowStore.getState().restoreSnapshot(persisted); } catch (e) { /* bad blob */ }
        }
        const { store: uiStore } = createUiStore();
        const { store: sessionStore } = createSessionStore();
        ref.current = {
            flowStore, flowEvents, uiStore, sessionStore,
            flowRegistry,
            client: null, syncBridge: null,
        };
    }
    return ref.current;
}
